import { TitleOfferFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';

const isJustWatchTV = (offer: TitleOfferFragment) => offer.package.technicalName === 'justwatchtv';
export function sortJustWatchTVFirst(offerA: TitleOfferFragment, offerB: TitleOfferFragment) {
	// Number(true) = 1, Number(false) = 0
	return Number(isJustWatchTV(offerB)) - Number(isJustWatchTV(offerA));
}
